import { Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { PhoneNumber } from "./PhoneNumber/PhoneNumber";
import { ValidationCode } from "./ValidationCode/ValidationCode";
import { UseFormMethods } from "react-hook-form";
import { INetwork, IPortinForm } from "@features/PortIn/interface/IPortinForm";
import { EPortInStep, isSuccess, isVerifying } from "@features/PortIn/components/ValidatePhoneNumber/enum/EPortInStep";

interface IParams {
    formMethods: UseFormMethods<IPortinForm>;
    hasTooManyAttempt: boolean;
    otpId: string;
    portInStep: EPortInStep;
    phoneNumberSelected: string;
    previousPhoneNumber?: string;
    variantStyleButton: "outlined" | "contained";
    setIsFinished(newValue: boolean): void;
    setOtpId(otpId: string): void;
    updatePortInStep(nextStep: EPortInStep): void;
    setHasTooManyAttempt(hasTooManyAttempt: boolean): void;
    setCurrentProvider(currentProvider: INetwork): void;
    setPhoneNumberSelected(phoneNumber: string): void;
}

export const ValidatePhoneNumberView = (props: IParams) => {
    const {
        portInStep,
        setIsFinished,
        setOtpId,
        updatePortInStep,
        otpId,
        variantStyleButton,
        previousPhoneNumber,
        setCurrentProvider,
        hasTooManyAttempt,
        setHasTooManyAttempt,
        formMethods,
        phoneNumberSelected,
        setPhoneNumberSelected,
    } = props;

    const { t } = useTranslation("portin");
    const displayValidationCode = isVerifying(portInStep);

    return (
        <Fragment>
            {!displayValidationCode && (
                <PhoneNumber
                    formMethods={formMethods}
                    hasTooManyAttempt={hasTooManyAttempt}
                    phoneNumberSelected={phoneNumberSelected}
                    portInStep={portInStep}
                    previousPhoneNumber={previousPhoneNumber}
                    setCurrentProvider={setCurrentProvider}
                    setHasTooManyAttempt={setHasTooManyAttempt}
                    setIsFinished={setIsFinished}
                    setOtpId={setOtpId}
                    setPhoneNumberSelected={setPhoneNumberSelected}
                    updatePortInStep={updatePortInStep}
                    variantStyleButton={variantStyleButton}
                />
            )}
            {displayValidationCode && (
                <ValidationCode
                    formMethods={formMethods}
                    otpId={otpId}
                    setHasTooManyAttempt={setHasTooManyAttempt}
                    setIsFinished={setIsFinished}
                    updatePortInStep={updatePortInStep}
                    variantStyleButton={variantStyleButton}
                />
            )}
            {isSuccess(portInStep) && (
                <Typography color="secondary" variant="normal">
                    {t("mobileNumberValidated")}
                </Typography>
            )}
        </Fragment>
    );
};
